export default __webpack_public_path__ + "static/media/twitter.48352121.svg";